import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { MemberDiscountService } from './member-discount.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MemberDiscountRequest } from './DTOs/member-discount-request';

@Component({
  selector: 'app-submit-member-discount',
    templateUrl: './submit-member-discount.component.html',
    providers: [UIBlockingService]

})
export class SubmitMemberDiscountComponent {
    constructor(private memberDiscountService: MemberDiscountService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    invalidDate = false;
    invalidStart = false;
    invalidEnd = false;
    discountValueCtrl = new FormControl("discountValue", [Validators.required]);
    startDateCtrl = new FormControl("startDate");
    endDateCtrl = new FormControl("endDate");
    redemptionLimitCtrl = new FormControl("redemptionLimit");

    memberDiscountForm: FormGroup = new FormGroup({
        discountValue: this.discountValueCtrl,
        startDate: this.startDateCtrl,
        endDate: this.endDateCtrl,
        redemptionLimit: this.redemptionLimitCtrl,
    });

    discountValue() { return this.memberDiscountForm.get('discountValue').value }
    startDate() { return this.memberDiscountForm.get('startDate').value }
    endDate() { return this.memberDiscountForm.get('endDate').value }
    redemptionLimit() { return this.memberDiscountForm.get('redemptionLimit').value }

    ngOnInit() {
        this.memberDiscountForm.reset();
    }

    submitMemberDiscount() {
        this.invalidStart = false;
        this.invalidEnd = false;
        const startDateParsed = this.parseDate(this.startDate());
        if (this.invalidDate) {
            this.invalidDate = false;
            this.invalidStart = true;
            return;
        }
        const endDateParsed = this.parseDate(this.endDate());
        if (this.invalidDate) {
            this.invalidDate = false;
            this.invalidEnd = true;
            return;
        }
        if (!this.memberDiscountForm.valid) return;
        var request = new MemberDiscountRequest(this.discountValue(), startDateParsed, endDateParsed, this.redemptionLimit());

        this.memberDiscountService.submitMemberDiscount(request)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.notificationService.success("submitted discount");
                    this.memberDiscountForm.reset();
                    this.blockUI.stop();
                }
            });
    }

    parseDate(dateString: string) {
        if (!dateString) {
            return null;
        }
        const formats = [
            /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
            /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
            /^\d{2}-\d{2}-\d{4}$/, // MM-DD-YYYY
            /^\d{2}.\d{2}.\d{4}$/, // MM.DD.YYYY
        ];

        let date: Date;

        for (const format of formats) {
            if (format.test(dateString)) {
                if (format === formats[0]) { // YYYY-MM-DD
                    date = new Date(dateString);
                } else if (format === formats[1]) { // MM/DD/YYYY
                    const [month, day, year] = dateString.split('/').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[2]) { // MM-DD-YYYY
                    const [month, day, year] = dateString.split('-').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[3]) { // MM.DD.YYYY
                    const [month, day, year] = dateString.split('.').map(Number);
                    date = new Date(year, month - 1, day);
                }

                break;
            }
        }
        if (!date || isNaN(date.getTime())) {
            this.invalidDate = true;
        }

        return date;
    }

}
